import * as actionTypes from "./actionTypes";
import * as types from "./types";

const initInsituExtractorListState: types.InsituExtractorListState = {
    pending: false,
    insituExtractors: {} as types.IInsituExtractorList,
    error: null,
};

export const InsituExtractorListReducer = (state = initInsituExtractorListState, action: types.InsituActions) => {
    switch (action.type) {
        case actionTypes.FETCH_INSITU_EXTRACTOR_LIST_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.FETCH_INSITU_EXTRACTOR_LIST_SUCCESS:
            return {
                ...state,
                pending: false,
                insituExtractors: action.payload.insituExtractors,
                error: null,
            };
        case actionTypes.FETCH_INSITU_EXTRACTOR_LIST_FAILURE:
            return {
                ...state,
                pending: false,
                insituExtractors: {} as types.IInsituExtractorList,
                error: action.payload.error,
            };

        default:
            return {
                ...state,
            };
    }
};

//insitu Extractor details
const initInsituExtractorDetailsState: types.InsituExtractorDetailsState = {
    pending: false,
    insituExtractor: null,
    error: null,
};
export const InsituExtractorDetailsReducer = (state = initInsituExtractorDetailsState, action: types.InsituDetailsActions) => {
    switch (action.type) {
        case actionTypes.FETCH_INSITU_EXTRACTOR_DETAILS_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.FETCH_INSITU_EXTRACTOR_DETAILS_SUCCESS:
            return {
                ...state,
                pending: false,
                insituExtractor: action.payload.insituExtractor,
                error: null,
            };
        case actionTypes.FETCH_INSITU_EXTRACTOR_DETAILS_FAILURE:
            return {
                ...state,
                pending: false,
                insituExtractors: {} as types.IInsituExtractorList,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};

const initInsituExtractorState: types.IPostInsituExtractorState = {
    pending: false,
    insituExtractor: null,
    error: null,
};

export const PostInsituExtractorReducer = (
    state = initInsituExtractorState,
    action: types.PostInsituExtractorActions
) => {
    switch (action.type) {
        case actionTypes.POST_INSITU_EXTRACTOR_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.POST_INSITU_EXTRACTOR_SUCCESS:
            return {
                ...state,
                pending: false,
                insituExtractor: action.payload.insituExtractor,
                error: null,
            };
        case actionTypes.POST_INSITU_EXTRACTOR_FAILURE:
            return {
                ...state,
                pending: false,
                insituExtractor: null,
                error: action.payload.error,
            };
        case actionTypes.POST_INSITU_EXTRACTOR_RESET:
            return {
                ...state,
                pending: false,
                insituExtractors: null,
                error: null,
            };
        default:
            return {
                ...state,
            };
    }
};

const initPutInsituExtractorState: types.IPutInsituExtractorState = {
    pending: false,
    insituExtractor: null,
    error: null,
};


export const PutInsituExtractorReducer = (
    state = initPutInsituExtractorState,
    action: types.PutInsituExtractorActions
) => {
    switch (action.type) {
        case actionTypes.PUT_INSITU_EXTRACTOR_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.PUT_INSITU_EXTRACTOR_SUCCESS:
            return {
                ...state,
                pending: false,
                insituExtractor: action.payload.insituExtractorStatus,
                error: null,
            };
        case actionTypes.PUT_INSITU_EXTRACTOR_FAILURE:
            return {
                ...state,
                pending: false,
                insituExtractor: null,
                error: action.payload.error,
            };
        case actionTypes.PUT_INSITU_EXTRACTOR_RESET:
            return {
                ...state,
                pending: false,
                insituExtractor: null,
                error: null,
            };
        default:
            return {
                ...state,
            };
    }
};

const initDeleteInsituExtractorState: types.IDeleteInsituExtractorState = {
    pending: false,
    deleteStatus: null,
    error: null,
};

export const DeleteExtractorReducer = (state = initDeleteInsituExtractorState, action: types.DeleteInsituExtractorActions) => {
    switch (action.type) {
        case actionTypes.DELETE_INSITU_EXTRACTOR_REQUEST:
            return {
                ...state,
                deleteStatus: null,
                pending: true,
            };
        case actionTypes.DELETE_INSITU_EXTRACTOR_SUCCESS:
            return {
                ...state,
                pending: false,
                deleteStatus: action.payload.deleteStatus,
                error: null,
            };
        case actionTypes.DELETE_INSITU_EXTRACTOR_FAILURE:
            return {
                ...state,
                pending: false,
                deleteStatus: null,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};